import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    },
    AdjusterMessage: {
        id: "claim.views.claim-detail.AdjusterMessage",
        defaultMessage: "Call us or send a message to your adjuster"
    },
    LossDescription: {
        id: "claim.views.claim-detail.Loss Description",
        defaultMessage: "Loss Description"
    },
    ContactPerson: {
        id: "claim.views.claim-detail.Contact Person",
        defaultMessage: "Contact Person"
    },
    PrimaryEmail: {
        id: "claim.views.claim-detail.Primary Email",
        defaultMessage: "Primary Email"
    },
    PrimaryPhone: {
        id: "claim.views.claim-detail.Primary Phone",
        defaultMessage: "Primary Phone"
    },
    LossItems: {
        id: "claim.views.claim-detail.Loss Items",
        defaultMessage: "Loss Items"
    },
    ClaimStatus: {
        id: "claim.views.claim-detail.claimStatus",
        defaultMessage: "Claim Status"
    }

});
